export default __webpack_public_path__ + "static/media/EM1750.34I-41297_-24636_0.50d216d5.jpg";